'use strict';

const Reflux = require('@muzzylane/reflux');
const uuid = require('uuid');
const find = require('lodash/find');
const findIndex = require('lodash/findIndex');
const isObject = require('lodash/isObject');
const merge = require('lodash/merge');
const assign = require('lodash/assign');
const reject = require('lodash/reject');
const has = require('lodash/has');

const ActivityActions = require('../actions/ActivityActions');
const ProjectActions = require('../actions/ProjectActions');
const ChannelActions = require('../actions/ChannelActions');
const OrganizationActions = require('../actions/OrganizationActions');
const ServerRequest = require('../actions/request');
const SignInStore = require('./SignInStore');
const ProjectStore = require('./ProjectStore');
const ForgeError = require('../util/error');
const ErrorConsts = require('../constants/error');
const SignInActions = require('../actions/sign_in_actions');
const StringUtil = require('../../../app/shared/StringUtil');
const Strings = require('../../../app/shared/Strings');

let activities = {};
let activityLocks = {};
let activityEditAccessInfo = {};
let activitySaves = {};
let activityAutoSaveInfo = {};
let activityLaunchCounts = {};
let activityStats = {};
let activityTags = {};
let projectIDs = [];
let publishCompatibility = {};
let publishValidation = {};
let actVersionsValidation = {};
let newActID = null;
let activityMetaTagCategories = null;
let activityMetaTags = {};
let activityToMetaTags = {}; // activityToMetaTags[activity_id][tag_category_id][tag_id] = {tagObject}
let metaTagsToActivities = {}; // metaTagsToActivities[tag_id] = [ {activity_id: 1, project_id: 2, channel_id: 3 }, ...]

let activityMetaTypes = {};
let activityToMetaType = {}; // activityToMetaType[activity_id][type_id] = {typeObject}
let metaTypesToActivities = {}; // metaTypesToActivities[type_id] = [ {activity_id: 1, project_id: 2, channel_id: 3 }, ...]
let activityScoreCategories = {};
let activityScoreCategoriesVersion = {}; // to detect when our data is for an older version

let shareLinkUrls = {};
let shareLinkData = {};

let initializedChannels = {};
let initializedProjects = {};
let initializedActivities = {};
let storeState = ""; // TODO: is this used? delete?
let message = ""; // TODO: is this used? delete?
let signedIn = false; // TODO: is this used? delete?
let action = {};

let pendingGotoComment = {}; // what comment do we navigate to after editing an activity 

const ActivityStore = Reflux.createStore({
    listenables: [ActivityActions, SignInActions, ProjectActions, OrganizationActions],

    init: function() {
        signedIn = SignInStore.getState().initializedLocal;
        this.listenTo(SignInStore, this.onSignInChange);
    },

    onSignInChange: function(signInStoreState){
        signedIn = signInStoreState.initializedLocal;
    },

    resetState: function() {
        initializedChannels = {};
        initializedProjects = {};
        initializedActivities = {};
        activities = {};
        activityLocks = {};
        activityEditAccessInfo = {};
        activityTags = {};
        activitySaves = {};
        activityAutoSaveInfo = {};
        activityLaunchCounts = {};
        activityStats = {};
        publishCompatibility = {};
        publishValidation = {};
        actVersionsValidation = {};
        activityMetaTagCategories = null;
        activityMetaTags = {};
        activityToMetaTags = {};
        metaTagsToActivities = {};
        activityMetaTypes = {};
        activityToMetaType = {};
        metaTypesToActivities = {};
        shareLinkUrls = {};
        shareLinkData = {};
        activityScoreCategories = {};
        activityScoreCategoriesVersion = {};
        newActID = null;
        // action = {};
        signedIn = SignInStore.getState().initializedLocal;
    },

    onSignOutCompleted: function(res) {
        this.resetState();
        this.emitStatus();
    },

    onSignOutFailed: function(err) {
        console.warn(err);
        this.resetState();
        this.emitStatus();
    },

    getState: function() {
        return {
            initializedChannels: initializedChannels,
            initializedProjects: initializedProjects,
            initializedActivities: initializedActivities,
            activities: activities,
            activityTags: activityTags,
            activitySaves: activitySaves,
            activityAutoSaveInfo: activityAutoSaveInfo,
            activityEditAccessInfo: activityEditAccessInfo,
            activityLaunchCounts: activityLaunchCounts,
            publishCompatibility: publishCompatibility,
            publishValidation: publishValidation,
            actVersionsValidation: actVersionsValidation,
            activityMetaTagCategories: activityMetaTagCategories,
            activityMetaTags: activityMetaTags,
            activityToMetaTags: activityToMetaTags,
            metaTagsToActivities: metaTagsToActivities,
            activityMetaTypes: activityMetaTypes,
            activityToMetaType: activityToMetaType,
            metaTypesToActivities: metaTypesToActivities,
            shareLinkUrls: shareLinkUrls,
            shareLinkData: shareLinkData,
            activityStats: activityStats,
            activityScoreCategories: activityScoreCategories,
            activityScoreCategoriesVersion: activityScoreCategoriesVersion,
            newActID: newActID,
            action: action
        }
    },

    getStateChannel: function(channelId) {
        const parsedChannelId = parseInt(channelId, 10);
        let filteredActs = {};
        let filteredActMetaTags = [];

        Object.keys(activities).forEach((projectId) => {
            // HACK attach each project id as a prop to the emitted activities object
            // empty projects will not be emitted otherwise
            if (!filteredActs[projectId]) filteredActs[projectId] = [];
            activities[projectId].forEach((activity) => {
                if (activity.owner_id === parsedChannelId) {
                    filteredActs[projectId].push(activity);
                }
            });
        });

        return {
            initialized: this.getChannelInitialized(channelId),
            activities: filteredActs,
            activityTags: activityTags, // TODO: filter for only activity tags in channel?
            activitySaves: activitySaves, // TODO: filter for only activity saves in channel?
            activityAutoSaveInfo:activityAutoSaveInfo, // TODO: filter for only activity autosaves in channel?
            activityEditAccessInfo: activityEditAccessInfo, // TODO: filter for only activities in channel?
            activityLaunchCounts: activityLaunchCounts, // TODO: filter for only activity tags in channel?
            activityStats: activityStats, // TODO: filter for only activity tags in channel?
            publishCompatibility: publishCompatibility, // TODO: filter for only activity tags in channel?
            publishValidation: publishValidation,
            actVersionsValidation: actVersionsValidation,
            activityMetaTagCategories: activityMetaTagCategories,
            activityMetaTags: activityMetaTags[parsedChannelId],
            activityToMetaTags: activityToMetaTags,
            metaTagsToActivities: metaTagsToActivities,
            activityMetaTypes: activityMetaTypes[parsedChannelId],
            activityToMetaType: activityToMetaType,
            metaTypesToActivities: metaTypesToActivities,
            shareLinkUrls: shareLinkUrls,
            shareLinkData: shareLinkData,
            action: action
        };
    },

    getStateProject: function(projectId, channelId) {
        const parsedProjectId = parseInt(projectId, 10);

        return {
            initialized: this.getProjectInitialized(projectId, channelId),
            activities: activities[parsedProjectId],
            activityTags: activityTags, // TODO: filter for only activity tags in project?
            activitySaves: activitySaves, // TODO: filter for only activity saves in project?
            activityAutoSaveInfo: activityAutoSaveInfo, // TODO: filter for only activity saves in project?
            activityEditAccessInfo: activityEditAccessInfo, // TODO: filter for only activities in project?
            activityLaunchCounts: activityLaunchCounts, // TODO: filter for only activity tags in project?
            activityStats: activityStats, // TODO: filter for only activity tags in project?
            publishCompatibility: publishCompatibility, // TODO: filter for only activity tags in project?
            publishValidation: publishValidation,
            actVersionsValidation: actVersionsValidation,
            activityToMetaTags: activityToMetaTags,
            metaTagsToActivities: metaTagsToActivities,
            activityMetaTypes: activityMetaTypes,
            activityToMetaType: activityToMetaType,
            metaTypesToActivities: metaTypesToActivities,
            shareLinkUrls: shareLinkUrls,
            shareLinkData: shareLinkData,
            action: action
        }
    },

    getStateActivity: function(activityId, projectId, channelId) {
        const parsedActId = parseInt(activityId, 10);
        const activity = find(activities[projectId], { id: parsedActId });

        return {
            initialized: this.getActivityInitialized(activityId, projectId, channelId),
            activity: activity,
            activityTags: activityTags, // TODO: filter for only activity-specific tags?
            activitySaves: activitySaves[parsedActId],
            activityAutoSaveInfo: activityAutoSaveInfo[parsedActId],
            activityEditAccessInfo: activityEditAccessInfo[parsedActId],
            activityLaunchCounts: activityLaunchCounts[parsedActId],
            activityStats: activityStats[parsedActId],
            activityLock: activityLocks[parsedActId] || null,
            publishCompatibility: publishCompatibility[parsedActId],
            publishValidation: publishValidation[parsedActId],
            actVersionsValidation: actVersionsValidation[parsedActId],
            activityToMetaTags: activityToMetaTags[parsedActId],
            metaTagsToActivities: metaTagsToActivities,
            activityMetaTypes: activityMetaTypes,
            activityToMetaType: activityToMetaType[parsedActId],
            metaTypesToActivities: metaTypesToActivities,
            shareLinkUrls: shareLinkUrls,
            shareLinkData: shareLinkData,
            action: action
        }
    },
    
    getStateScoreCategories: function() {
        return {
            activityScoreCategories,
            action,
        }
    },

    isScoreCategoryVersion: function(activity_id, version) {
        if (activityScoreCategoriesVersion[activity_id]) {
            return activityScoreCategoriesVersion[activity_id] === version;
        }
        return false;
    },

    getAndClearEditGotoComment(activity_id) {
        var comment = pendingGotoComment[activity_id];
        delete pendingGotoComment[activity_id];
        return comment;
    },
    
    setEditGotoComment(activity_id, comment_id, comment_location) {
        pendingGotoComment[activity_id] = {
            id: comment_id,
            location: comment_location, // fallback for student feedback comments
        }
    },
    
    setChannelInitialized(channelId, initialized=true) {
        const pChannelId = parseInt(channelId, 10);
        initializedChannels[pChannelId] = initialized;
    },

    setProjectInitialized(projectId, initialized=true) {
        const pProjectId = parseInt(projectId, 10);
        initializedProjects[pProjectId] = initialized;
    },

    setActivityInitialized(activityId) {
        const pActivityId = parseInt(activityId, 10);
        initializedActivities[pActivityId] = true;
    },

    getChannelInitialized(channelId) {
        const pChannelId = parseInt(channelId, 10);
        return initializedChannels[channelId];
    },

    getProjectInitialized(projectId, channelId) {
        const pProjectId = parseInt(projectId, 10);
        return this.getChannelInitialized(channelId) || initializedProjects[pProjectId];
    },

    getActivityInitialized(activityId, projectId, channelId) {
        const pActivityId = parseInt(activityId, 10);
        return this.getChannelInitialized(channelId) || this.getProjectInitialized(projectId) || initializedActivities[pActivityId];
    },

    emitStatus: function() {
        // console.log("activity store: EMIT");
        this.trigger(this.getState());
        action = {};
    },

    findActivity: function(projectID, activityID, deleteActivity) {
        projectID = parseInt(projectID, 10);
        activityID = parseInt(activityID, 10);

        if(activities[projectID]) {
            var actIndex = findIndex(activities[projectID], {'id': activityID})
            if(actIndex >= 0 && isObject(activities[projectID][actIndex])) {

                if(deleteActivity) {
                    delete activities[projectID][actIndex];
                    return;
                }
                else {
                    return activities[projectID][actIndex];
                }
            }
        }

        throw "Activity with projectID " + projectID + " activityID " + activityID + " not found in store.";
    },

    //attempt to merge newProp into ActivityStore's activity object.
    //ASSUMES newProp adds something useful or updates an existing activity prop
    //unable to find object with given projectId -> throw
    updateActivityMerge: function(projectId, activityId, newProp) {
        const pProjectId = parseInt(projectId, 10);
        const pActivityId = parseInt(activityId, 10);

        if (activities[pProjectId]) {
            const actIndex = findIndex(activities[pProjectId], {'id': pActivityId})
            if (actIndex >= 0 && isObject(activities[pProjectId][actIndex])) {
                merge(activities[pProjectId][actIndex], newProp)
                return;
            }
        }

        throw `Activity with projectId ${pProjectId} activityId ${pActivityId} not found in store.`;
    },

    // TODO: this seems to be the same thing as updateActivityMerge(). remove one?
    _updateActivityData: function(activityId, changes) {
        for (let projectId in activities) {
            const i = findIndex(activities[projectId], { id: parseInt(activityId, 10) });
            if (i >= 0) {
                activities[projectId][i] = assign({}, activities[projectId][i], changes);
                break;
            }
        }
    },

    onCreateProjectCompleted: function(actionId, newProj) {
        activities[newProj.id] = [];
        this.setProjectInitialized(newProj.id);
        this.emitStatus();
    },

    /* TODO: add projectId to ProjectActions.archiveProject callback so that stores can clean up
    onArchiveProjectCompleted: function(actionId, res) {

    },
    */

    _mergeUpdatedActivity: function(newAct) {
        if (!activities[newAct.project_id]) {
            activities[newAct.project_id] = [];
            activities[newAct.project_id].push(newAct);
        }
        else {
            const curIndex = findIndex(activities[newAct.project_id], { 'activity_id': newAct.activity_id });
            if (curIndex < 0) {
                activities[newAct.project_id].push(newAct);
            }
            else {
                activities[newAct.project_id][curIndex] = newAct;
            }

        }

        if (!!newAct.saves) {
            activitySaves[newAct.id] = newAct.saves;
        }

        if (!!newAct.autoSaveInfo) {
            activityAutoSaveInfo[newAct.id] = newAct.autoSaveInfo;
        }

    },

    onGetActivityCompleted: function(actionId, activityId, newAct) {
        // console.log("onGetActivityCompleted: ", actionId, activityId, projectId, channelId, newAct);
        action = { id: actionId };
        this.setActivityInitialized(activityId);
        this._mergeUpdatedActivity(newAct);
        activityAutoSaveInfo[newAct.id] = newAct.autoSaveInfo; // this request will always contain autosave info
        this.emitStatus();
    },

    onGetActivityFailed: function(actionId, activityId, err) {
        console.warn("onGetActivityFailed: ", actionId, activityId, err);
        action = { id: actionId };
        this.setActivityInitialized(activityId);

        if (err.status) {
            switch (err.status) {
                case 403:
                    action.error = new ForgeError({ message: Strings['en'].common.NOT_ALLOWED, stack: null });
                    break;
                default:
                    action.error = new ForgeError({message: ErrorConsts.INTERNAL_GENERAL});
            }
        }
        else {
            action.error = err;
        }

        this.emitStatus();
    },

    onGetProjectActivitiesCompleted: function(actionId, projectId, channelId, res) {
        // console.log('onGetProjectActivitiesCompleted', actionId, projectId, channelId, res);
        action = { id: actionId };
        activities[projectId] = res;
        this.setProjectInitialized(projectId);
        this.emitStatus();
    },

    onGetProjectActivitiesFailed: function(actionId, projectId, channelId, err)  {
        console.warn('onGetProjectActivitiesFailed', actionId, projectId, channelId, err);
        action = { id: actionId, error: err };
        this.setProjectInitialized(projectId);
        this.emitStatus();
    },

    onGetChannelActivitiesCompleted: function(actionId, channelId, res) {
        // console.log('onGetChannelActivitiesCompleted', actionId, channelId, res);
        action = { id: actionId };
        this.setChannelInitialized(channelId);
        Object.keys(res).forEach((projectId) => {
            activities[projectId] = res[projectId];
        })

        this.emitStatus();
    },

    onGetChannelActivitiesFailed: function(actionId, channelId, err)  {
        console.warn('onGetChannelActivitiesFailed', actionId, channelId, err);
        this.setChannelInitialized(channelId);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onCreateActivityCompleted: function(actionID, projectId, actInfo) {
        // console.log("onCreateActivityCompleted");
        action.id = actionID;
        action.newActID = actInfo.id;
        if (!activities[projectId]) activities[projectId] = [];
        activities[projectId].push(actInfo);
        this.setActivityInitialized(actInfo.id, actInfo.project_id, actInfo.owner_id);
        this.emitStatus();
    },

    onCreateActivityFailed: function(actionID, projectId, err) {
        console.warn("onCreateActivityFailed: ", actionID, projectId, err);
        action.id = actionID;

        if (err.status) {
            switch (err.status) {
                case 403:
                    action.error = new ForgeError({ message: Strings['en'].common.NOT_ALLOWED, stack: null });
                    break;
                default:
                    action.error = new ForgeError({message: ErrorConsts.INTERNAL_GENERAL});
            }
        }
        else {
            action.error = err;
        }

        this.emitStatus();
    },

    onArchiveActivityCompleted: function(actionId, res, projectId, activityId) {
        // console.log("onArchiveActivityCompleted");
        action = { id: actionId };
        if (activities[projectId]) {
            const parsedActId = parseInt(activityId, 10);
            activities[projectId] = activities[projectId].filter(act => act.id !== parsedActId);
        }

        this.emitStatus();
    },

    onArchiveActivityFailed: function(actionId, err) {
        console.warn("onArchiveActivityFailed: ", actionId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onPublishActivityCompleted: function(actionId, activityId, actInfo) {
        console.log("onPublishActivityCompleted", actionId, activityId, actInfo);
        action = { id: actionId };

        if (!activities[actInfo.project_id]) {
            activities[actInfo.project_id] = [];
            activities[actInfo.project_id].push(actInfo);
        }
        else {
            const curIndex = findIndex(activities[actInfo.project_id], { 'activity_id': actInfo.activity_id });

            if (curIndex < 0) {
                activities[actInfo.project_id].push(actInfo);
            }
            else {
                activities[actInfo.project_id][curIndex] = actInfo;
            }
        }

        activitySaves[actInfo.id] = actInfo.saves;
        activityAutoSaveInfo[actInfo.id] = actInfo.autoSaveInfo;

        this.emitStatus();
    },

    onPublishActivityFailed: function(actionId, activityId, err) {
        console.warn("onPublishActivityFailed: ", actionId, activityId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onPublishIsBreakingReset: function(activityId) {
        if (publishCompatibility[activityId]) delete publishCompatibility[activityId];
        this.emitStatus();
    },

    onPublishIsBreakingCompleted: function(actionId, activityId, res) {
        // console.log("onPublishIsBreakingCompleted");
        action = { id: actionId };
        publishCompatibility[activityId] = res;
        this.emitStatus();
    },

    onPublishIsBreakingFailed: function(actionId, activityId, err) {
        console.warn("onPublishIsBreakingFailed: ", actionId, activityId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onPublishGetValidationReset: function(activityId) {
        if (publishValidation[activityId]) delete publishValidation[activityId];
        this.emitStatus();
    },

    onPublishGetValidationCompleted: function(actionId, activityId, res) {
        // console.log("onPublishGetValidationCompleted");
        action = { id: actionId };
        publishValidation[activityId] = res;
        this.emitStatus();
    },

    onPublishGetValidationFailed: function(actionId, activityId, err) {
        console.warn("onPublishGetValidationFailed: ", actionId, activityId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onUnpublishCompleted: function(actionId, activityId, res) {
        console.log("onUnpublishCompleted", actionId, activityId, res);
        action = { id: actionId };
        this._mergeUpdatedActivity(res);
        this.emitStatus();
    },

    onUnpublishFailed: function(actionId, activityId, err) {
        console.warn("onUnpublishFailed: ", actionId, activityId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },    

    onGetValidationForVersionCompleted: function(actionId, activityId, version, res) {
        // console.log("onGetValidationForVersionompleted");
        action = { id: actionId };
        if (!actVersionsValidation[activityId]) actVersionsValidation[activityId] = {};
        actVersionsValidation[activityId][version] = res;
        this.emitStatus();
    },

    onGetValidationForVersionFailed: function(actionId, activityId, version, err) {
        console.warn("onGetValidationForVersionFailed: ", actionId, activityId, version, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onRenameActivityCompleted: function(actionId, res, projectId, activityId, name) {
        // console.log("onRenameActivityCompleted", actionId, res);
        action = { id: actionId };

        let refreshActs = false;
        try {
            this.updateActivityMerge(projectId, activityId, { meta_data: { title: name } });
        }
        catch(err) {
            console.warn('Activity Store - Rename Activity: ' + err + '  Refreshing activity.');
            refreshActs = true;
        }
        finally {
            this.emitStatus();
            if (refreshActs) ActivityActions.getActivity(uuid.v4(), { activityId: activityId });
        }
    },

    onRenameActivityFailed: function(actionId, err) {
        console.warn("onRenameActivityFailed: ", actionId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onSetDescriptionActivityCompleted: function(actionId, res, projectId, activityId, description) {
        // console.log("onSetDescriptionActivityCompleted", actionId, res);
        action = { id: actionId };

        let refreshActs = false;
        try {
            this.updateActivityMerge(projectId, activityId, { meta_data: { description: description } });
        }
        catch(err) {
            console.warn('Activity Store - SetDescriptionActivity: ' + err + '  Refreshing activity.');
            refreshActs = true;
        }
        finally {
            this.emitStatus();
            if (refreshActs) ActivityActions.getActivity(uuid.v4(), { activityId: activityId });
        }
    },

    onSetDescriptionActivityFailed: function(actionId, err) {
        console.warn("onSetDescriptionActivityFailed: ", actionId, err);
        action.id = { id: actionId, error: err };
        this.emitStatus();
    },

    onSetPlayTextActivityCompleted: function(actionId, res, projectId, activityId, playText, resumeText) {
        // console.log("onSetPlayTextActivityCompleted", actionId, res);
        action = { id: actionId };

        let refreshActs = false;
        try {
            this.updateActivityMerge(projectId, activityId, { meta_data: { playText, resumeText } });
        }
        catch(err) {
            console.warn('Activity Store - SetPlayTextActivity: ' + err + '  Refreshing activity.');
            refreshActs = true;
        }
        finally {
            this.emitStatus();
            if (refreshActs) ActivityActions.getActivity(uuid.v4(), { activityId: activityId });
        }
    },

    onSetPlayTextActivityFailed: function(actionId, err) {
        console.warn("onSetPlayTextActivityFailed: ", actionId, err);
        action.id = { id: actionId, error: err };
        this.emitStatus();
    },


    onTransferActivityCompleted: function(actionId, activityId, toProjectId, fromProjectId, res) {
        // console.log("onTransferActivityCompleted", actionId, activityId, toProjectId, fromProjectId, res);
        action = { id: actionId };
        const pActivityId = parseInt(activityId, 10);
        const pFromProjectId = parseInt(fromProjectId, 10);

        // remove activity record from old project
        if (activities[pFromProjectId]) {
            const oldActivityIndex = findIndex(activities[fromProjectId], { id: pActivityId });
            if (oldActivityIndex >= 0) {
                activities[fromProjectId] = activities[fromProjectId].filter(act => act.id !== pActivityId);
            }
        }

        // add to new project
        if (!activities[res.project_id]) activities[res.project_id] = [];
        activities[res.project_id].push(res);
        this.emitStatus();
    },

    onTransferActivityFailed: function(actionId, activityId, toProjectId, fromProjectId, err) {
        console.warn("onTransferActivityFailed: ", actionId, activityId, toProjectId, fromProjectId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onCopyActivityCompleted: function(actionId, activityId, toProjectId, fromProjectId, newAct) {
        // console.log("onCopyActivityCompleted:", actionId, activityId, toProjectId, fromProjectId, res);
        action = { id: actionId };
        if (!activities[toProjectId]) activities[toProjectId] = [];
        activities[toProjectId].push(newAct);
        this.emitStatus();
    },

    onCopyActivityFailed: function(actionId, activityId, toProjectId, fromProjectId, err) {
        console.warn("onCopyActivtyFailed: ", actionId, activityId, toProjectId, fromProjectId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onUpdateActivityVersionCompleted: function(actionId, projectId, activityId, version) {
        action = { id: actionId };

        let refreshActs = false;
        try {
            this.updateActivityMerge(projectId, activityId, { version: version });
        }
        catch(err) {
            console.warn('Activity Store - UpdateActivityVersion: ' + err + '  Refreshing activity.');
            refreshActs = true;
        }
        finally {
            this.emitStatus();
            if (refreshActs) ActivityActions.getActivity(uuid.v4(), { activityId: activityId });
        }
    },

    onUpdateActivityAutoSaveInfoCompleted: function(actionId, projectId, activityId, autoSaveInfo) {
        action = { id: actionId };

        let refreshActs = false;
        try {
            this.updateActivityMerge(projectId, activityId, { autoSaveInfo: autoSaveInfo }); // TODO remove?
            activityAutoSaveInfo[activityId] = autoSaveInfo; // new definitive location
        }
        catch(err) {
            console.warn('Activity Store - UpdateActivitySaveInfo: ' + err + '  Refreshing activity.');
            refreshActs = true;
        }
        finally {
            this.emitStatus();
            if (refreshActs) ActivityActions.getActivity(uuid.v4(), { activityId: activityId });
        }
    },

    onAddActivityImageCompleted: function(actionId, activityId, res) {
        // console.log("onAddActivityImageCompleted:", actionId, activityId, res);
        action = { id: actionId };

        let refreshActs = false;
        try {
            this.updateActivityMerge(res.project_id, res.activity_id, { meta_data: { image_url: res.url } });
        }
        catch(err) {
            console.warn('Activity Store - AddActivityImage: ' + err + '  Refreshing activity.');
            refreshActs = true;
        }
        finally {
            this.emitStatus();
            if (refreshActs) ActivityActions.getActivity(uuid.v4(), { activityId: activityId });
        }
    },

    onAddActivityImageFailed: function(actionId, activityId, err) {
        console.warn("onAddActivityImageFailed: ", actionId, activityId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onGetActivityLockStatusCompleted: function(actionId, projectId, activityId, lockData) {
        // console.log('onGetActivityLockStatusCompleted', actionId, projectId, activityId, lockData);
        action = { id: actionId };
        activityLocks[activityId] = lockData;
        this.emitStatus();
    },

    onGetActivityLockStatusFailed: function(actionId, projectId, activityId, err) {
        console.warn('onGetActivityLockStatusFailed', actionId, projectId, activityId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onSetDisplayNameCompleted: function(actionId, res, projectId, activityId, displayName) {
        // console.log("onSetDisplayNameCompleted", actionId, res, projectId, activityId, displayName);
        action = { id: actionId };

        let refreshActs = false;
        try {
            this.updateActivityMerge(projectId, activityId, { meta_data: { display_name: displayName } });
        }
        catch(err) {
            console.warn('Activity Store - SetDisplayName: ' + err + '  Refreshing activity.');
            refreshActs = true;
        }
        finally {
            this.emitStatus();
            if (refreshActs) ActivityActions.getActivity(uuid.v4(), { activityId: activityId });
        }
    },

    onSetDisplayNameFailed: function(actionID, err) {
        console.warn("onSetDisplayNameFailed: ", actionID, err);
        action.id = { id: actionID, error: err };
        this.emitStatus();
    },

    onGetActivityTagsCompleted: function(actionId, activityId, tagRecords) {
        action = { id: actionId };
        activityTags[activityId] = tagRecords;
        this._updateActivityData(activityId, {
            tags: tagRecords.map(t => t.tag), // DEPRECATED
            integration_tags: tagRecords,
        });
        this.emitStatus();
    },

    onGetActivityTagsFailed: function(actionId, err) {
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onAddActivityTagCompleted: function(actionId, activityId, tagRecord, res) {
        action = { id: actionId };
        if (activityTags[activityId].indexOf(t => t.id === tagRecord.id) < 0) {
            activityTags[activityId].push(tagRecord);
            this._updateActivityData(activityId, {
                tags: activityTags[activityId].map(t => t.tag), // DEPRECATED
                integration_tags: activityTags[activityId],
            });
        }

        this.emitStatus();
    },

    onAddActivityTagFailed: function(actionId, err) {
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onAddActivityTagsCompleted: function(actionId, activityId, tagRecords, res) {
        action = { id: actionId };
        tagRecords.forEach((tagRecord) => {
            if (activityTags[activityId].indexOf(t => t.id === tagRecord.id) < 0) {
                activityTags[activityId].push(tagRecord);
                this._updateActivityData(activityId, {
                    // tags: activityTags[activityId].map(t => t.tag), // DEPRECATED
                    integration_tags: activityTags[activityId],
                });
            }
        });

        this.emitStatus();
    },

    onAddActivityTagsFailed: function(actionId, err) {
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onDeleteActivityTagCompleted: function(actionId, activityId, tagRecord, res) {
        action = { id: actionId };
        activityTags[activityId] = reject(activityTags[activityId], aTag => aTag.id == tagRecord.id);
        this._updateActivityData(activityId, {
            tags: activityTags[activityId].map(t => t.tag), // DEPRECATED
            integration_tags: activityTags[activityId],
        });
        this.emitStatus();
    },

    onDeleteActivityTagFailed: function(actionId, err) {
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onDeleteAutosaveCompleted: function(actionId, params, res) {
        var projectId = parseInt(params.projectId, 10);
        var activityId = parseInt(params.activityId, 10);
        action = { id: actionId };
        var autoSaveInfo = {
            available: false,
            moreRecent: false,
        };

        let refreshActs = false;
        try {
            this.updateActivityMerge(projectId, activityId, { autoSaveInfo: autoSaveInfo });
        }
        catch(err) {
            console.warn('Activity Store - onDeleteAutosaveCompleted: ' + err + '  Refreshing activity.');
            refreshActs = true;
        }
        finally {
            this.emitStatus();
            if (refreshActs) ActivityActions.getActivity(uuid.v4(), { activityId: activityId });
        }
    },

    onDeleteAutosaveFailed: function(actionId, err) {
        action = { id: actionId, error: err };
        this.emitStatus();
    },


    onGetActivitySavesCompleted: function(actionId, activityId, res) {
        // console.log('onGetActivitySavesCompleted:', actionId, activityId, res);
        action = { id: actionId };
        activitySaves[activityId] = res;
        this.emitStatus();
    },

    onGetActivitySavesFailed: function(actionId, activityId, err) {
        console.warn('onGetActivitySavesFailed:', actionId, activityId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onGetActivityStatsCompleted: function(actionId, activityId, res) {
        // console.log('onGetActivityStatsCompleted:', actionId, activityId, res);
        action = { id: actionId };
        activityStats[activityId] = res;
        activityLaunchCounts[activityId] = res.counterTotal;
        this.emitStatus();
    },

    onGetActivityStatsFailed: function(actionId, activityId, err) {
        console.warn('onGetActivityStatsFailed:', actionId, activityId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onForceUnlockActivityCompleted: function(actionId, params,res) {
        action = { id: actionId };
        this.emitStatus();
    },
    onForceUnlockActivityFailed: function(actionId, err) {
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onArchiveProjectCompleted: function(actionId, projectId, res) {
        action = { id: actionId };

        this.setProjectInitialized(projectId, false);
        delete activities[projectId];
        this.emitStatus();
    },

    onDeleteFolderCompleted: function(actionId, folderId, channelId, res) {
        res.deletedProjectIds.forEach((pId) => {
            this.setProjectInitialized(pId, false);
            delete activities[pId];
        });
        this.emitStatus();
    },

    onCopyProjectCompleted: function(actionId, newProj) {
        activities[newProj.id] = [];
        this.setProjectInitialized(newProj.id, false);
        ActivityActions.getProjectActivities(uuid.v4(), { projectId: newProj.id, channelId: newProj.channelId });
        this.emitStatus();
    },

    onGetActivityEditAccessInfoCompleted: function(actionId, activityId, res) {
        // console.log('onGetActivityEditAccessInfoCompleted:', actionId, activityId, res);
        action = { id: actionId };
        activityEditAccessInfo[activityId] = res;
        this.emitStatus();
    },

    onGetActivityEditAccessInfoFailed: function(actionId, activityId, err) {
        console.warn('onGetActivityEditAccessInfoFailed:', actionId, activityId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onSendActivityNonAuthorFeedbackCompleted: function(actionId, params, res) {
        // console.log('onSendActivityNonAuthorFeedbackCompleted:', actionId, params, res);
        action = { id: actionId };
        this.emitStatus();
    },
    onSendActivityNonAuthorFeedbackFailed: function(actionId, params, err) {
        console.warn('onSendActivityNonAuthorFeedbackFailed:', actionId, params, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onModifyShareLinkCompleted: function(actionId, activityId, res) {
        console.log('onModifyShareLinkCompleted', actionId, activityId, res);
        action = { id: actionId };
        this._updateActivityData(activityId, { ...res });
        this.emitStatus();
    },

    onModifyShareLinkFailed: function(actionId, activityId, err) {
        console.warn('onModifyShareLinkFailed', actionId, activityId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onGetShareLinkUrlCompleted: function(actionId, shareId, res) {
        console.log('onGetShareLinkUrlCompleted', actionId, shareId, res);
        action = { id: actionId };
        shareLinkUrls[shareId] = res.url;
        shareLinkData[shareId] = res.data; // should contain channelId, activityId, and permissions (from org account features)
        this.emitStatus();
    },

    onGetShareLinkUrlFailed: function(actionId, shareId, err) {
        console.warn('onGetShareLinkUrlFailed', actionId, shareId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },
    
    onManageOrgIntegrationTagCompleted: function(actionId, orgId, managementTasks, tagInfo) {
        const self = this;
        action = { id: actionId };

        if (managementTasks.add.activities) {
            Object.keys(managementTasks.add.activities).forEach((activityId) => {
                self._addIntegrationTag(null, activityId, tagInfo);
            });
        }

        if (managementTasks.remove.activities) {
            Object.keys(managementTasks.remove.activities).forEach((activityId) => {
                self._removeIntegrationTag(null, activityId, tagInfo);
            });
        }

        this.emitStatus();
    },

    _addIntegrationTag(projectId=null, activityId, tagInfo) {
        if (!activityTags[activityId]) activityTags[activityId] = [];

        if (activityTags[activityId].indexOf(t => t.tag === tagInfo.tag) < 0) {
            activityTags[activityId].push(tagInfo);
        }

        let projActs = activities;
        if (projectId) { // narrow search if projectId is provided
            projActs = { projectId: activities[projectId] };
        }

        // add or merge new tag to existing tags
        Object.keys(projActs).forEach((projectId) => {
            const actIndex = findIndex(projActs[projectId], act => act.id === parseInt(activityId, 10));
            if (actIndex >= 0) {
                const tagIndex = findIndex(projActs[projectId][actIndex].integration_tags, t => t.id === tagInfo.id);
                if (tagIndex >= 0) { // replace (update)
                    projActs[projectId][actIndex].integration_tags.splice(tagIndex, 1, tagInfo);
                }
                else { // add
                    projActs[projectId][actIndex].integration_tags.push(tagInfo);
                }
            }
        });
    },

    _removeIntegrationTag(projectId=null, activityId, tagInfo) {
        if (!activityTags[activityId]) activityTags[activityId] = [];
        const aTagsTagIndex = !!activityTags[activityId] ? activityTags[activityId].indexOf(t => t.tag === tagInfo.tag) : -1;
        if (aTagsTagIndex >= 0) {
            activityTags[activityId].splice(aTagsTagIndex, 1);
        }

        let projActs = activities;
        if (projectId) { // narrow search if projectId is provided
            projActs = { projectId: activities[projectId] };
        }

        // delete tag from existing tags if present
        Object.keys(projActs).forEach((projectId) => {
            const actIndex = findIndex(projActs[projectId], act => act.id === parseInt(activityId, 10));
            if (actIndex >= 0) {
                const tagIndex = findIndex(projActs[projectId][actIndex].integration_tags, t => t.id === tagInfo.id);
                if (tagIndex >= 0) { // remove
                    projActs[projectId][actIndex].integration_tags.splice(tagIndex, 1);
                }
            }
        });
    },

    onGetActMetaTagsForOrgCompleted: function(actionId, orgId, res) {
        action = { id: actionId };
        activityMetaTagCategories = res.categories;
        activityMetaTags[orgId] = res.tags;
        this.emitStatus();
    },
    onGetActMetaTagsForOrgFailed: function(actionId, orgId, err) {
        console.warn('onGetActMetaTagsForOrgFailed:', actionId, orgId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onGetActMetaTagsForOrgViaActCompleted: function(actionId, orgId, actId, res) {
        action = { id: actionId };
        activityMetaTagCategories = res.categories;
        activityMetaTags[orgId] = res.tags;
        this.emitStatus();
    },
    onGetActMetaTagsForOrgViaActFailed: function(actionId, orgId, actId, err) {
        console.warn('onGetActMetaTagsForOrgViaActFailed:', actionId, orgId, actId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onConfirmImportActMetaTagChangesCompleted: function(actionId, orgId, categoryId, tags) {
        console.log('ActivityStore.onConfirmImportActMetaTagChangesCompleted: ', actionId, orgId, categoryId, tags);
        action = { id: actionId };
        tags.forEach((tag) => {
            this._mergeNewTag(tag);
        })
        this.emitStatus();
    },

    _mergeNewTag(newTag) {
        if (!activityMetaTags[newTag.user_id]) activityMetaTags[newTag.user_id] = {};
        if (!activityMetaTags[newTag.user_id][newTag.atc_id]) activityMetaTags[newTag.user_id][newTag.atc_id] = {};
        activityMetaTags[newTag.user_id][newTag.atc_id][newTag.id] = newTag;
    },

    onAddOrgActMetaTagCompleted: function(actionId, newTag) {
        action = { id: actionId };
        this._mergeNewTag(newTag);
        this.emitStatus();
    },
    onAddOrgActMetaTagFailed: function(actionId, err) {
        console.warn('onAddOrgActMetaTagFailed:', actionId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onDeleteActMetaTagCompleted: function(actionId, orgId, categoryId, tagId, updatedTags) {
        action = { id: actionId };
        if (
            activityMetaTags[orgId]
            && activityMetaTags[orgId][categoryId]
            && activityMetaTags[orgId][categoryId][tagId]
        ) {
            delete activityMetaTags[orgId][categoryId][tagId];
        }

        updatedTags.forEach((updatedTag) => {
            this._mergeNewTag(updatedTag);
        });
        this.emitStatus();
    },
    onDeleteActMetaTagFailed: function(actionId, orgId, categoryId, tagId, err) {
        console.warn('onDeleteActMetaTagFailed:', actionId, orgId, tagId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onReorderActMetaTagCompleted: function(actionId, updatedTags) {
        action = { id: actionId };
        updatedTags.forEach((updatedTag) => {
            this._mergeNewTag(updatedTag);
        });
        this.emitStatus();
    },
    onReorderActMetaTagFailed: function(actionId, err) {
        console.warn('onReorderActMetaTagFailed:', actionId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onUpdateActMetaTagCompleted: function(actionId, updatedTag) {
        action = { id: actionId };
        this._mergeNewTag(updatedTag);
        this.emitStatus();
    },
    onUpdateActMetaTagFailed: function(actionId, err) {
        console.warn('onUpdateActMetaTagFailed:', actionId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onGetActMetaTagsForActCompleted: function(actionId, actId, res) {
        action = { id: actionId };
        activityToMetaTags[actId] = res;
        this.emitStatus();
    },
    onGetActMetaTagsForActFailed: function(actionId, actId, err) {
        console.warn('onGetActMetaTagsForActFailed', actionId, actId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    _mergeActMetaTagToAct(actId, tagRecord) {
        if (!activityToMetaTags[actId]) activityToMetaTags[actId] = {};
        if (!activityToMetaTags[actId][tagRecord.atc_id]) activityToMetaTags[actId][tagRecord.atc_id] = {};
        activityToMetaTags[actId][tagRecord.atc_id][tagRecord.id] = tagRecord;
    },

    _removeActMetaTagToAct(actId, categoryId, tagId) {
        if (has(activityToMetaTags, `${actId}.${categoryId}.${tagId}`)) {
            delete activityToMetaTags[actId][categoryId][tagId];
        }
    },

    onGetActivitiesForMetaTagCompleted: function(actionId, channelId, tagId, res) {
        action = { id: actionId };
        metaTagsToActivities[tagId] = res;
        this.emitStatus();
    },
    onGetActivitiesForMetaTagFailed: function(actionId, channelId, tagId, err) {
        console.warn('onGetActivitiesForMetaTagFailed', actionId, channelId, tagId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onAddActMetaTagToActByIdCompleted: function(actionId, actId, addedTag) {
        action = { id: actionId };
        this._mergeActMetaTagToAct(actId, addedTag);
        this.emitStatus();
    },
    onAddActMetaTagToActByIdFailed: function(actionId, actId, err) {
        console.warn('onAddActMetaTagToActByIdFailed', actionId, actId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onAddActMetaTagsToActByIdsCompleted: function(actionId, actId, addedTags) {
        action = { id: actionId };
        addedTags.forEach(addedTag => this._mergeActMetaTagToAct(actId, addedTag));
        this.emitStatus();
    },
    onAddActMetaTagsToActByIdsFailed: function(actionId, actId, err) {
        console.warn('onAddActMetaTagsToActByIdsFailed', actionId, actId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onAddFreeFormActMetaTagToActCompleted: function(actionId, actId, tagObj) {
        action = { id: actionId };
        this._mergeNewTag(tagObj.tag);
        this._mergeActMetaTagToAct(actId, tagObj.tag_to_act);
        this.emitStatus();
    },
    onAddFreeFormActMetaTagToActFailed: function(actionId, actId, err) {
        console.warn('onAddFreeFormActMetaTagToActFailed', actionId, actId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onRemoveActMetaTagFromActByIdCompleted: function(actionId, actId, categoryId, tagId, res) {
        action = { id: actionId };
        this._removeActMetaTagToAct(actId, categoryId, tagId);
        this.emitStatus();
    },
    onRemoveActMetaTagFromActByIdFailed: function(actionId, actId, categoryId, tagId, err) {
        console.warn('onRemoveActMetaTagFromActByIdFailed', actionId, categoryId, actId, tagId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onRemoveActMetaTagsFromActByIdsCompleted: function(actionId, actId, categoryId, tagIds, res) {
        action = { id: actionId };
        tagIds.forEach((tagId) => {
            this._removeActMetaTagToAct(actId, categoryId, tagId);
        });
        this.emitStatus();
    },
    onRemoveActMetaTagsFromActByIdsFailed: function(actionId, actId, categoryId, tagIds, err) {
        console.warn('onRemoveActMetaTagsFromActByIdsFailed', actionId, categoryId, actId, tagIds, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },


    // Activity Meta Types ----------------------------------------------------------------------
    _formatMetaTypeObj(obj) { // unescape type_display_name from escaped db data
        if (!isObject(obj) || !obj.type_display_name) {
            return obj;
        }

        return {
            ...obj,
            type_display_name: StringUtil.unescapeString(obj.type_display_name),
        };
    },

    onGetActMetaTypesForOrgCompleted: function(actionId, channelId, res) {
        // console.log('onGetActMetaTypesForOrgCompleted', actionId, channelId, res);
        action = { id: actionId };
        activityMetaTypes[channelId] = res.map(mt => this._formatMetaTypeObj(mt));
        this.emitStatus();
    },
    onGetActMetaTypesForOrgFailed: function(actionId, channelId, err) {
        console.warn('onGetActMetaTypesForOrgFailed', actionId, channelId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onGetActMetaTypesForOrgViaActCompleted: function(actionId, channelId, activityId, res) {
        // console.log('onGetActMetaTypesForOrgViaActCompleted', actionId, channelId, res);
        action = { id: actionId };
        activityMetaTypes[channelId] = res.map(mt => this._formatMetaTypeObj(mt));
        this.emitStatus();
    },
    onGetActMetaTypesForOrgViaActFailed: function(actionId, channelId, activityId, err) {
        console.warn('onGetActMetaTypesForOrgViaActFailed', actionId, channelId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onGetActivitiesForMetaTypeCompleted: function(actionId, channelId, typeId, res) {
        // console.log('onGetActivitiesForMetaTypeCompleted', actionId, channelId, typeId, res);
        action = { id: actionId };
        metaTypesToActivities[typeId] = res;
        this.emitStatus();
    },
    onGetActivitiesForMetaTypeFailed: function(actionId, channelId, typeId, err) {
        console.warn('onGetActivitiesForMetaTypeFailed', actionId, channelId, typeId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onAddOrgActMetaTypeCompleted: function(actionId, channelId, res) {
        // console.log('onAddOrgActMetaTypeCompleted', actionId, channelId, res);
        action = { id: actionId };
        if (!activityMetaTypes[channelId]) activityMetaTypes[channelId] = [];
        activityMetaTypes[channelId].push(this._formatMetaTypeObj(res));
        this.emitStatus();
    },
    onAddOrgActMetaTypeFailed: function(actionId, channelId, err) {
        console.warn('onAddOrgActMetaTypeFailed', actionId, channelId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onDeleteActMetaTypeCompleted: function(actionId, channelId, typeId, res) {
        // console.log('onDeleteActMetaTypeCompleted', actionId, channelId, typeId, res);
        action = { id: actionId };
        if (!activityMetaTypes[channelId]) {
            activityMetaTypes[channelId] = [];
        }
        else {
            activityMetaTypes[channelId] = reject(activityMetaTypes[channelId], type => type.id === typeId);
        }

        if (metaTypesToActivities[typeId]) metaTypesToActivities[typeId] = [];

        Object.keys(activityToMetaType).forEach((actId) => {
            if (
                !!activityToMetaType[actId]
                && activityToMetaType[actId].id === typeId
            ) {
               activityToMetaType[actId] = null; 
            }

        });
        this.emitStatus();
    },
    onDeleteActMetaTypeFailed: function(actionId, channelId, typeId, err) {
        console.warn('onDeleteActMetaTypeFailed', actionId, channelId, typeId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onUpdateActMetaTypeCompleted: function(actionId, channelId, typeId, res) {
        // console.log('onUpdateActMetaTypeCompleted', actionId, channelId, typeId, res);
        const formattedRes = this._formatMetaTypeObj(res);
        action = { id: actionId };
        if (!activityMetaTypes[channelId]) {
            activityMetaTypes[channelId] = [];
            activityMetaTypes[channelId].push(formattedRes);
        }
        else {
            activityMetaTypes[channelId] = activityMetaTypes[channelId].map((type) => {
                if (type.id === typeId) return formattedRes;

                return type;
            });
        }

        this.emitStatus();
    },
    onUpdateActMetaTypeFailed: function(actionId, channelId, typeId, err) {
        console.warn('onUpdateActMetaTypeFailed', actionId, channelId, typeId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onGetActMetaTypeForActCompleted: function(actionId, activityId, res) {
        // console.log('onGetActMetaTypeForActCompleted', actionId, activityId, res);
        action = { id: actionId };
        activityToMetaType[activityId] = this._formatMetaTypeObj(res);
        this.emitStatus();
    },
    onGetActMetaTypeForActFailed: function(actionId, activityId, err) {
        console.warn('onGetActMetaTypeForActFailed', actionId, activityId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onAddActMetaTypeToActByIdCompleted: function(actionId, activityId,res) {
        // console.log('onAddActMetaTypeToActByIdCompleted', actionId, activityId, res);
        action = { id: actionId };
        activityToMetaType[activityId] = this._formatMetaTypeObj(res);
        this.emitStatus();
    },
    onAddActMetaTypeToActByIdFailed: function(actionId, activityId,err) {
        console.warn('onAddActMetaTypeToActByIdFailed', actionId, activityId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onRemoveActMetaTypeFromActByIdCompleted: function(actionId, activityId, res) {
        // console.log('onRemoveActMetaTypeFromActByIdCompleted', actionId, activityId, res);
        action = { id: actionId };
        activityToMetaType[activityId] = {};
        this.emitStatus();
    },
    onRemoveActMetaTypeFromActByIdFailed: function(actionId, activityId, err) {
        console.warn('onRemoveActMetaTypeFromActByIdFailed', actionId, activityId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onGetActivityScoreCategoriesCompleted: function(actionId, activityId, res, version) {
        action = { id: actionId };
        activityScoreCategories[activityId] = res;
        activityScoreCategoriesVersion[activityId] = version;
        this.emitStatus();
    },

    onGetActivityScoreCategoriesFailed: function(actionId, activityId, err) {
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onUpdateActShortCourseMetaDataCompleted: function(actionId, activityId, res) {
        action = { id: actionId };
        console.log("onUpdateShortCourseMetaDataCompleted:",actionId, activityId, res); // FIXME: remove debug spam
        this._updateActivityData(activityId, {
            short_course_meta_data: res
        });
        this.emitStatus();
    },
    onUpdateActShortCourseMetaDataFailed: function(actionId, activityId, err) {
        action = { id: actionId, error: err };
        console.log("onUpdateShortCourseMetaDataFailed:",actionId, activityId, err); // FIXME: remove debug spam
        this.emitStatus();
    },


});

module.exports = ActivityStore;
